const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoEditConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'administration',
            route: `partner-groups/${this.$route.params.id}`,
            method: 'get'
          },
          post: {
            module: 'administration',
            route: `partner-groups/${this.$route.params.id}`,
            method: 'post'
          }
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.mainEditState = !!edit
        },
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('administration/partner_group.edit_group_details'),
            showBackButton: {
              onGoBack: () => {
                this.$router.replace({ name: 'PartnerGroups' }).then()
              }
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'name',
                    label: this.$t('administration/partner_group.name'),
                    placeholder: this.$t('administration/partner_group.enter_group_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
